<template>
  <vs-popup class=""
            id="popup"
            title="CREATE RAW MATERIAL FROM EXISTING RAW MATERIAL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
                <small class="label">Supplier product code</small>
                <vs-input disabled type="text"  name="supplier_product_code" class="w-full" v-model="supplier_product_code"/>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="manufacturing_site" name="manufacturing_site" rules="required" v-slot="{ errors }">
                <small class="label">Manufacturing Sites</small>
                <v-select  :clearable="false" name="manufacturing_site" placeholder="" label="site_name" v-model="site_id" :reduce="option => option.id" :options="sites" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.site_name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      form: {
        is_food_grade:  false,
        is_compliant_food_law: false
      },
      countryCodes: [],
      sites: [],
      raw_material_id: null,
      site_id: null,
      supplier_product_code: null
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, supplier_product_code) {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading()
        this.raw_material_id = id
        this.supplier_product_code = supplier_product_code
        await this.loadManufacturingSites()
        this.open = true;
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()

      }
    },
    async onClickUpdate () {
      const vue = this;
      this.$vs.loading()
       try {
         await SupplierRawMaterialRepository.createRawMaterialFromExisting(this.site_id, {raw_material_id: [this.raw_material_id]})
         this.showSuccessMessage('Raw material created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async loadCountrCode() {
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async loadManufacturingSites() {
      this.$vs.loading()
      try {
        const {data} = await SupplierManufactureRepository.getAllManufacturerSites(this.page, this.filterQuery, 100, this.sort)
        this.sites =  data.data
        console.log(this.sites)
        this.meta = data.meta
      } catch (e) {

      }
      this.$vs.loading.close()
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
